interface OpeningHours {
    [day: string]: {
        open: string;
        close: string;
    };
}

const standardHours = { open: '8:30am', close: '7:00pm' }

export const getOpeningHours = () => {

    const openingHours: OpeningHours = {
        Monday: standardHours,
        Tuesday: standardHours,
        Wednesday: standardHours,
        Thursday: standardHours,
        Friday: { open: '8:30am', close: '5:00pm' },
        Saturday: { open: '', close: '' },
        Sunday: { open: '', close: '' }
    };

    return openingHours;
};